import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealthReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 5.3569C14.4059 3.42024 17.9539 3.55674 20.1988 5.7664C22.6004 8.13022 22.6004 11.9694 20.1988 14.3332L12.7016 21.7126C12.3128 22.0954 11.688 22.0961 11.2985 21.7127L4.04299 14.5713C4.04048 14.5688 4.03798 14.5663 4.0355 14.5638L3.80118 14.3332C1.39961 11.9694 1.39961 8.13018 3.80118 5.76636C6.04614 3.55669 9.59409 3.4202 12 5.3569ZM5.45347 13.1533L12 19.5969L18.7958 12.9079C20.4014 11.3276 20.4014 8.77206 18.7958 7.19177C17.1815 5.6028 14.5576 5.6028 12.9433 7.19177L12.7015 7.42978C12.3123 7.81286 11.6877 7.81286 11.2985 7.42978L11.0567 7.19173C9.44233 5.60276 6.81849 5.60276 5.20415 7.19173C3.59862 8.77202 3.59862 11.3275 5.20415 12.9078L5.446 13.1459C5.4485 13.1483 5.45099 13.1508 5.45347 13.1533Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.7814 9.26416C12.0935 9.32567 12.3328 9.57731 12.3786 9.89205L12.8829 13.3591L13.6368 12.5617C13.7785 12.4118 13.9756 12.3269 14.1818 12.3269H16C16.4142 12.3269 16.75 12.6627 16.75 13.0769C16.75 13.4911 16.4142 13.8269 16 13.8269H14.5049L12.9086 15.5153C12.7111 15.7242 12.4115 15.8018 12.1374 15.7151C11.8632 15.6283 11.6628 15.3925 11.6214 15.108L11.2003 12.2123L10.4639 13.4585C10.3289 13.6868 10.0834 13.8269 9.81818 13.8269H8C7.58579 13.8269 7.25 13.4911 7.25 13.0769C7.25 12.6627 7.58579 12.3269 8 12.3269H9.39021L10.9907 9.61845C11.1525 9.34464 11.4694 9.20265 11.7814 9.26416Z",
		fill: "currentColor"
	})]
});
export default SvgHealthReport;
